var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16182 7.81514C2.30338 7.81514 1.60747 8.51105 1.60747 9.36949V17.2825C1.60747 18.141 2.30338 18.8369 3.16182 18.8369H16.727C17.5855 18.8369 18.2814 18.141 18.2814 17.2825V9.36949C18.2814 8.51105 17.5855 7.81514 16.727 7.81514H3.16182ZM0.194427 9.36949C0.194427 7.73065 1.52297 6.4021 3.16182 6.4021H16.727C18.3659 6.4021 19.6944 7.73065 19.6944 9.36949V17.2825C19.6944 18.9214 18.3659 20.2499 16.727 20.2499H3.16182C1.52297 20.2499 0.194427 18.9214 0.194427 17.2825V9.36949Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58605 4.28261C3.58605 2.33241 5.16845 0.75 7.11865 0.75C9.06886 0.75 10.6513 2.33241 10.6513 4.28261V7.1087C10.6513 7.4989 10.3349 7.81522 9.94474 7.81522H7.11865C5.16845 7.81522 3.58605 6.23281 3.58605 4.28261ZM7.11865 2.16304C5.94886 2.16304 4.99909 3.11281 4.99909 4.28261C4.99909 5.45241 5.94886 6.40217 7.11865 6.40217H9.23822V4.28261C9.23822 3.11281 8.28845 2.16304 7.11865 2.16304Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7705 2.16304C11.6007 2.16304 10.6509 3.11281 10.6509 4.28261V6.40217H12.7705C13.9403 6.40217 14.89 5.45241 14.89 4.28261C14.89 3.11281 13.9403 2.16304 12.7705 2.16304ZM9.23787 4.28261C9.23787 2.33241 10.8203 0.75 12.7705 0.75C14.7207 0.75 16.3031 2.33241 16.3031 4.28261C16.3031 6.23281 14.7207 7.81522 12.7705 7.81522H9.94439C9.55419 7.81522 9.23787 7.4989 9.23787 7.1087V4.28261Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94439 5.27173C10.3346 5.27173 10.6509 5.58805 10.6509 5.97825H9.94439H9.23787C9.23787 5.58805 9.55419 5.27173 9.94439 5.27173ZM9.94439 5.97825C9.23787 5.97825 9.23787 5.97819 9.23787 5.97825V19.5435C9.23787 19.9337 9.55419 20.25 9.94439 20.25C10.3346 20.25 10.6509 19.9337 10.6509 19.5435V5.97825C10.6509 5.97819 10.6509 5.97825 9.94439 5.97825Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentWhiteIcon);
export default __webpack_public_path__ + "static/media/presentWhiteIcon.1cd09c31fa88e37d955b87cbf7c7d09f.svg";
export { ForwardRef as ReactComponent };